// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"b9ed326a64733818","5285":"a2a838273f7b9b1f"}[chunkId] + ".css";
};